import React, { useEffect, useState, useMemo } from 'react';

import GetAppIcon from '@material-ui/icons/GetApp';
import SendIcon from '@material-ui/icons/Send';
import { Grid, makeStyles, Button, TextField } from '@material-ui/core';
import { Alert } from '@material-ui/lab';

import { useDispatch , useSelector } from 'react-redux';
import lineEndpoint from 'app/api/services/lineEndpoint';
import { downloadFile } from 'app/utils/forms/files';
import { errorHandler } from 'app/utils/errorHandler';

import DialogComponent from 'app/components/DialogComponent';
import SaveBox from '../../components/SaveBox';
import Loading from 'app/layouts/Loading';
import notification from '../../../../config/notification';
import InfoLineCompany from '../../components/InfoLineCompany';
import { STATUS_CODES } from '../../../../config/status';

function ScheduleModal(props) {
  const classes = useStyles();
  const { open, onClose, data, updateSchedule } = props;

  const selectedLineStore = useSelector(state => state.line.selected);
  const isStrip = useSelector(state => state.line.isStrip);

  const [loading, setLoading] = useState(false);
  const [nuApostila, setNuApostila] = useState('');
  const [idFile, setIdFile] = useState('');
  const [processId, setProcessId] = useState(null);
  const [requestId, setRequestId] = useState(null);
  const [requestNumber, setRequestNumber] = useState('');
  const [processNumber, setProcessNumber] = useState('');
  const [requestSituation, setRequestSituation] = useState(0);

  const dispatch = useDispatch();

  const canSendToSignature = useMemo(() => {
    if(requestId){
      if(requestSituation !== STATUS_CODES.EM_ANALISE &&
        requestSituation !== STATUS_CODES.AGUARDANDO_RESOLUCAO_PENDENCIAS &&
        requestSituation !== STATUS_CODES.RETORNO_DIRETOR_GERAL &&
        requestSituation !== STATUS_CODES.AGUARDANDO_AJUSTES_DOCUMENTO){
        return false;
      }
    }
    return (processId || requestId);
  },[processId, requestId, requestSituation]);

  useEffect(() => {
    (() => {
      if (data.schedule) {
        setProcessNumber(data.schedule.nuProcesso);
        setNuApostila(data.schedule.nuApostilaFmt);
        setIdFile(data.schedule.idFile);
        setProcessId(data.schedule.cdProcesso);
        setRequestId(data.schedule.cdSolicitacao);
        setRequestNumber(data.schedule.nuSolicitacaoFmt);
      }
      if(data.requestProcessValues){
        setRequestSituation(data.requestProcessValues.cdSituacao);
      }
    })();
  }, [data]);

  const clear = () => {};

  const handleCancel = () => {
    onClose();
    clear();
  };

  const handleGenerate = async () => {
    setLoading(true);
    try {
      if (data?.schedule?.cdLinhaQuadroHorario) {
        const response = await lineEndpoint.generateScheduleFile(
          data.schedule.cdLinhaQuadroHorario
        );
        if (response && response.status === 200) {
          notification('Quadro de horário gerado com sucesso', {
            type: 'success',
          });
          updateSchedule(response.data);
          setIdFile(response.data.idFile);
          if(isStrip) {
            const hasActiveContract = await lineEndpoint.getActiveContractByLine(selectedLineStore.cdLinha);
            if(hasActiveContract && !hasActiveContract.data) {
              notification('O contrato de concessão/permissão para a linha não é válido ou está vencido, favor verificar', {
                toastId: 'ACTIVE_CONTRACT',
                type: 'warning',
              });
            }
          }

        }
      } else {
        notification('Quadro de horário não identificado', {
          toastId: 'VALIDATION',
          type: 'error',
        });
      }
    } catch (error) {
      errorHandler(error.response?.status, error.response?.data?.message);
    } finally {
      setLoading(false);
    }
  };

  const sendSchedule = async () => {
    if (!data.schedule) {
      notification('Erro ao identificar quadro de horário', {
        toastId: 'SCH_NO_SCHEDULE',
        type: 'error',
      });
      return;
    }
    setLoading(true);
    let response = null;
    let resultMessage;

    if (requestId && requestId !== '') {
      response = await lineEndpoint.sendSchedulesToRequest(data.schedule);
      resultMessage = 'na solicitação ' + requestNumber;
    } else if (processId && processId !== '') {
      response = await lineEndpoint.sendSchedulesToProcess(data.schedule);
      resultMessage = 'no processo ' + processNumber;
    }
    if (!response || response.status !== 200) {
      notification('Erro ao encaminhar quadro de horários', {
        toastId: 'SCH_SEND_ERROR',
        type: 'error',
      });
      setLoading(false);
      return;
    }
    notification(`Apostila de quadro de horário incluída ${resultMessage} com sucesso`, {
      toastId: 'SCH_SUCESS',
      type: 'success',
    });
    setLoading(false);
    onClose();
  }

  return (
    <DialogComponent
      title={'Emissão de Quadro de Horário'}
      subtitle={''}
      open={open}
      onClose={onClose}
    >
      <>
        {loading && <Loading />}
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <Alert severity="info">
              Antes de emitir o documento, certifique-se de que todas as informações do quadro de
              horários foram salvas!
            </Alert>
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              label='Nº Apostila do Q.H.'
              name='deNome'
              value={nuApostila}
              disabled
              variant='filled'
              fullWidth
              margin="dense"
              size="small"
              InputLabelProps={{ shrink: true }}
            />
          </Grid>

          <InfoLineCompany selectedLine={selectedLineStore} inputProps={{margin:"dense", size:"small"}} />

          <Grid item xs={12}>
            {idFile && idFile !== '' && (
              <>
                <Button
                  color="secondary"
                  className={classes.button}
                  startIcon={<GetAppIcon />}
                  onClick={async () => await downloadFile({ idFile, dispatch })}
                >
                  Exibir
                </Button>
                {canSendToSignature && (
                  <Button
                    color="primary"
                    className={classes.button}
                    startIcon={<SendIcon />}
                    onClick={() => sendSchedule()}
                  >
                    Encaminhar
                  </Button>
                )}
              </>
            )}
          </Grid>

          <Grid item xs={12}>
            <SaveBox
              onCancel={handleCancel}
              onSave={handleGenerate}
              onSaveColor={'secondary'}
              firstButtonLabel={'VOLTAR'}
              middleButtonLabel={'Gerar'}
              onSaveStyles={{ color: '#fff' }}
              removeSpacing={true}
            />
          </Grid>
        </Grid>
      </>
    </DialogComponent>
  );
}

const useStyles = makeStyles(theme => ({
  button: {
    marginRight: '20px',
  },
}));

export default ScheduleModal;
